import React from "react";
import { Home, Plane, Building2 } from "lucide-react";

// Mostra un badge compatto in base al work_mode salvato sulla timbratura.
// Se work_mode è null/undefined non mostra nulla (compatibilità record vecchi).
export default function WorkModeBadge({ mode, size = "sm" }) {
  if (!mode || mode === "office") {
    // Office è il default implicito → niente badge per non sporcare la UI
    return null;
  }
  const conf = {
    smartworking: {
      label: "Smart",
      Icon: Home,
      cls: "bg-emerald-100 text-emerald-800 border-emerald-300",
    },
    trasferta: {
      label: "Trasferta",
      Icon: Plane,
      cls: "bg-[#FFF0E3] text-[#E85D00] border-[#FF7A29]/40",
    },
    office: {
      label: "Sede",
      Icon: Building2,
      cls: "bg-blue-50 text-blue-700 border-blue-200",
    },
  }[mode];
  if (!conf) return null;
  const { Icon, label, cls } = conf;
  const sz = size === "xs" ? "text-[9px] px-1.5 py-0" : "text-[10px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-bold uppercase tracking-widest whitespace-nowrap ${cls} ${sz}`}
      data-testid={`work-mode-${mode}`}
      title={`Modalità: ${label}`}
    >
      <Icon className="w-3 h-3"/> {label}
    </span>
  );
}
